import "@polymer/polymer/polymer-legacy.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import "@polymer/paper-button/paper-button.js";
import "@polymer/iron-form/iron-form.js";
import "@polymer/paper-spinner/paper-spinner-lite.js";
import "./success.js";
import "./make-api-request.js";
import "./shared-styles.js";
import { PolymerElement } from "@polymer/polymer/polymer-element.js";
class ResendVerificationEmail extends PolymerElement {
    static get template() {
        return html `
            <style include="shared-styles">
                :host {
                    display: block;
                    padding: 10px;
                    height: calc(100vh - 20px);
                    background: -webkit-linear-gradient(
                        45deg,
                        #0077b5,
                        #008891
                    );
                }
                .container {
                    width: 500px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    margin: 0 auto;
                }

                #return {
                    display: block;
                    margin: 0 auto;
                    width: 200px;
                    text-align: center;
                    background-color: #2672ae;
                    color: white;
                }

                .header {
                    color: rgba(0, 0, 0, 0.67);
                    font-size: 20px;
                    text-align: center;
                }

                paper-spinner-lite:not([active]) {
                    display: none;
                }

                paper-button.indigo {
                    display: flex;
                    margin-top: 10px;
                    margin-bottom: 10px;
                    background-color: #2672ae;
                    color: white;
                    --paper-button-raised-keyboard-focus: {
                        background-color: var(--paper-pink-a200) !important;
                        color: white !important;
                    }
                }

                paper-button.indigo[disabled] {
                    background-color: #e6e6e6;
                    color: var(--paper-grey-500);
                }
            </style>
            <div class="container">
                <div class="card">
                    <h2 class="header">Resend Verification Email</h2>
                    <p class="description">
                        You can use this form to request a new verification
                        email.
                    </p>
                    <iron-form id="emailForm">
                        <form>
                            <paper-input
                                id="email"
                                type="email"
                                no-label-float="true"
                                label="Email"
                                on-value-changed="emailFormChanged"
                                required=""
                                auto-validate=""
                                style="width: 100%;"
                            ></paper-input>
                            <!--Submit-->
                            <paper-button
                                id="submitEmail"
                                raised=""
                                on-click="submit"
                                disabled="[[invalid]]"
                                class="indigo"
                            >
                                Continue
                                <paper-spinner-lite
                                    id="submitSpinner"
                                    hidden=""
                                ></paper-spinner-lite>
                            </paper-button>
                        </form>
                    </iron-form>
                </div>
            </div>
        `;
    }
    static get is() {
        return "resend-verification-email";
    }
    static get properties() {
        return {
            apiBaseUrl: {
                type: String,
                notify: true,
            },
            data: {
                type: Object,
                value: undefined,
                notify: true,
            },
            invalid: {
                type: Boolean,
                value: true,
                // observer: "invalidChanged",
            },
        };
    }
    emailFormChanged() {
        const emailForm = this.$.email;
        this.invalid = !emailForm.validate();
    }
    returnPage() {
        console.log("RETURNED");
        this.dispatchEvent(new CustomEvent("changeRoute", {
            bubbles: true,
            composed: true,
            detail: {
                route: ``,
            },
        }));
    }
    async submit() {
        const { submitSpinner } = this.$;
        const emailValue = this.$.email.value;
        submitSpinner.active = true;
        const response = await fetch(`${this.apiBaseUrl}/registration/resendVerificationEmail`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                email: emailValue,
            }),
        });
        try {
            if (!response.ok) {
                const e = await response.json();
                this.dispatchEvent(new CustomEvent("toastMessage", {
                    bubbles: true,
                    composed: true,
                    detail: {
                        message: `An error has occurred. Please contact support if this error persists.`,
                        type: "error",
                        id: e.error.trackingId,
                    },
                }));
                submitSpinner.active = false;
                return;
            }
            await response.json();
            this.dispatchEvent(new CustomEvent("toastMessage", {
                bubbles: true,
                composed: true,
                detail: {
                    message: "If user is registered verification email has been sent. Please check your email.",
                },
            }));
            this.$.email.value = "";
        }
        catch (e) {
            console.error(e);
            this.dispatchEvent(new CustomEvent("toastMessage", {
                bubbles: true,
                composed: true,
                detail: {
                    message: `${e.message || "An error has occurred"}. Please contact support if this error persists.`,
                    type: "error",
                },
            }));
        }
        submitSpinner.active = false;
    }
}
window.customElements.define(ResendVerificationEmail.is, ResendVerificationEmail);
//# sourceMappingURL=resend-verification-email.js.map